// Game-type catalogue + helpers shared by player Book flow and admin/manager screens.

export const GAME_TYPES = [
    { value: "football_5v5", label: "5v5 Football", sport: "Football" },
    { value: "football_6v6", label: "6v6 Football", sport: "Football" },
    { value: "football_7v7", label: "7v7 Football", sport: "Football" },
    { value: "football_9v9", label: "9v9 Football", sport: "Football" },
    { value: "box_cricket", label: "Box Cricket", sport: "Box Cricket" },
    { value: "box_cricket_with_pitch", label: "Box Cricket (with Pitch)", sport: "Box Cricket" },
    { value: "box_cricket_without_pitch", label: "Box Cricket (no Pitch)", sport: "Box Cricket" },
    { value: "cricket_nets", label: "Cricket Nets", sport: "Box Cricket" },
];

export function gameTypeToSport(gt) {
    const found = GAME_TYPES.find(g => g.value === gt);
    if (found) return found.sport;
    if (typeof gt === "string" && gt.startsWith("football")) return "Football";
    if (typeof gt === "string" && gt.includes("cricket")) return "Box Cricket";
    return "Other";
}

export function gameTypeLabel(gt) {
    const found = GAME_TYPES.find(g => g.value === gt);
    return found ? found.label : (gt || "Facility");
}

export function groupFacilitiesBySport(facilities = []) {
    const groups = {};
    [...facilities]
        .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
        .forEach(f => {
            const sport = gameTypeToSport(f.game_type);
            if (!groups[sport]) groups[sport] = [];
            groups[sport].push(f);
        });
    return groups;
}
